import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingglass = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.1553 12.3095H13.8137L17.347 15.8595C17.6887 16.2012 17.6887 16.7595 17.347 17.1012C17.0053 17.4429 16.447 17.4429 16.1053 17.1012L12.5637 13.5595V12.9012L12.3387 12.6679C11.172 13.6679 9.58034 14.1845 7.88867 13.9012C5.57201 13.5095 3.72201 11.5762 3.43867 9.24286C3.00534 5.71786 5.97201 2.75119 9.49701 3.18452C11.8303 3.46786 13.7637 5.31786 14.1553 7.63452C14.4387 9.32619 13.922 10.9179 12.922 12.0845L13.1553 12.3095ZM5.06367 8.55952C5.06367 10.6345 6.73867 12.3095 8.81367 12.3095C10.8887 12.3095 12.5637 10.6345 12.5637 8.55952C12.5637 6.48452 10.8887 4.80952 8.81367 4.80952C6.73867 4.80952 5.06367 6.48452 5.06367 8.55952Z",
		fill: "#AAC3DF"
	})
});
export default SvgMagnifyingglass;
